import { Context, createContext } from 'react'
import { AuthenticationContext } from '../../../types'

export const AuthenticatedContext: Context<AuthenticationContext | null> = createContext<AuthenticationContext | null>(
  null
)
